module.exports = __webpack_public_path__ + "c5d74d4c29a5cb22de0d954b76f53a35.svg";